import styled from 'styled-components';

export const MyEbonsPageContainer = styled.main`
    &#p-my-ebons {
        margin-bottom: 60px;

        .or {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 60px 0 0;
            width: calc(100% / 15 - 15px - 0.01px);
        }

        .period {
            margin-top: 30px;
        }

        @media (max-width: ${props => props.theme.medium}) {
            .or {
                margin: 25px 0 0;
                width: inherit;
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/reminder/MyEbonsPageStyle.js